<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Simulador",
            items: [{ text: "Inicio", href: "/" }, { text: "Análisis", href: "/web/analisis/panel" }, { text: "Simulador", active: true }],
            user: JSON.parse(document.querySelector('meta[name="user"]')?.content || '{}'),
            isLoading: false,
            isSyncingHubSpot: false,
            periodo: 'anio',
            selectedYear: 2026,
            selectedMonth: new Date().getMonth() + 1,
            carreraFiltro: '',
            searchQuery: '',
            currentPage: 1,
            pageSize: 100,
            resumen: { actividades: 0, meses: 0, carreras: 0, contactos: 0, contactos_unicos: 0 },
            simuladorSync: { available: false, last_synced_at: null, last_hubspot_created_at: null, last_status: null, last_message: null, last_totals: {} },
            meses: [],
            contactos: [],
            carrerasDisponibles: [],
        };
    },
    computed: {
        opcionesCarrera() {
            return this.carrerasDisponibles;
        },
        contactosFiltradosCount() {
            return this.contactosFiltrados.length;
        },
        contactosFiltrados() {
            if (!this.carreraFiltro) return this.contactos;
            return this.contactos.filter(c => c.carrera === this.carreraFiltro);
        },
        contactosBuscados() {
            const query = String(this.searchQuery || '').trim().toLowerCase();
            if (!query) {
                return this.contactosFiltrados;
            }

            return this.contactosFiltrados.filter((contacto) => {
                const values = [
                    contacto?.mes_label,
                    contacto?.carrera,
                    this.nombreContacto(contacto),
                    contacto?.rut,
                    contacto?.email,
                    contacto?.celular,
                    contacto?.curso,
                    contacto?.establecimiento,
                    contacto?.preferencia_1,
                    contacto?.preferencia_2,
                    contacto?.preferencia_3,
                    contacto?.ranking,
                    contacto?.actividad,
                    contacto?.colegio_actividad,
                    contacto?.codigo_actividad,
                    contacto?.hubspot_actividad_id,
                ];

                return values.some((value) => String(value || '').toLowerCase().includes(query));
            });
        },
        totalPages() {
            return Math.max(1, Math.ceil(this.contactosBuscados.length / this.pageSize));
        },
        contactosPaginados() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.contactosBuscados.slice(start, start + this.pageSize);
        },
        paginationStart() {
            if (!this.contactosBuscados.length) return 0;
            return ((this.currentPage - 1) * this.pageSize) + 1;
        },
        paginationEnd() {
            return Math.min(this.currentPage * this.pageSize, this.contactosBuscados.length);
        },
        preferencias1Consolidadas() {
            return this.consolidarPreferencias(this.contactosFiltrados, 'preferencia_1');
        },
        preferencias2Consolidadas() {
            return this.consolidarPreferencias(this.contactosFiltrados, 'preferencia_2');
        },
        chartPreferencias1() {
            return {
                series: [{ name: 'Contactos', data: this.preferencias1Consolidadas.map(p => p.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#8e44ad'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '62%' } },
                    xaxis: {
                        categories: this.preferencias1Consolidadas.map(p => p.preferencia || 'Sin preferencia'),
                        labels: { style: { fontSize: '11px' } }
                    },
                    yaxis: { labels: { style: { fontSize: '10px', maxWidth: 160 } } },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#252C5F'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' contactos' } }
                }
            };
        },
        chartPreferencias2() {
            return {
                series: [{ name: 'Contactos', data: this.preferencias2Consolidadas.map(p => p.total) }],
                options: {
                    chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
                    colors: ['#16a085'],
                    plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '62%' } },
                    xaxis: {
                        categories: this.preferencias2Consolidadas.map(p => p.preferencia || 'Sin preferencia'),
                        labels: { style: { fontSize: '11px' } }
                    },
                    yaxis: { labels: { style: { fontSize: '10px', maxWidth: 160 } } },
                    dataLabels: { enabled: true, style: { fontSize: '11px', colors: ['#252C5F'] } },
                    grid: { borderColor: '#f0f2fa' },
                    tooltip: { y: { formatter: v => v + ' contactos' } }
                }
            };
        },
        mesesDisponibles() {
            return [
                { value: 1, label: 'Enero' },
                { value: 2, label: 'Febrero' },
                { value: 3, label: 'Marzo' },
                { value: 4, label: 'Abril' },
                { value: 5, label: 'Mayo' },
                { value: 6, label: 'Junio' },
                { value: 7, label: 'Julio' },
                { value: 8, label: 'Agosto' },
                { value: 9, label: 'Septiembre' },
                { value: 10, label: 'Octubre' },
                { value: 11, label: 'Noviembre' },
                { value: 12, label: 'Diciembre' },
            ];
        }
    },
    mounted() {
        if (!this.puedeVerAnalisis()) {
            window.location.href = '/';
            return;
        }
        this.cargar();
    },
    watch: {
        carreraFiltro() {
            this.currentPage = 1;
        },
        searchQuery() {
            this.currentPage = 1;
        },
        periodo() {
            this.currentPage = 1;
        },
        selectedMonth() {
            this.currentPage = 1;
        },
    },
    methods: {
        puedeVerAnalisis() {
            return ['1', '2'].includes(String(this.user && this.user.id ? this.user.id : ''))
                || this.user.rol === 'SuperAdmin'
                || this.user.rol === 'Admin';
        },
        normalizarPreferencia(valor) {
            const normalizada = String(valor || '').replace(/\s+/g, ' ').trim();
            return normalizada || 'Sin preferencia';
        },
        consolidarPreferencias(contactos, campo) {
            const totales = contactos.reduce((acc, contacto) => {
                const preferencia = this.normalizarPreferencia(contacto?.[campo]);
                acc[preferencia] = (acc[preferencia] || 0) + 1;
                return acc;
            }, {});

            return Object.entries(totales)
                .map(([preferencia, total]) => ({ preferencia, total }))
                .sort((a, b) => b.total - a.total)
                .slice(0, 12);
        },
        cargar() {
            this.isLoading = true;
            axios.get('/api/get_simulador_analisis', {
                params: {
                    periodo: this.periodo,
                    year: 2026,
                    month: this.selectedMonth,
                }
            })
                .then(res => {
                    if (res.data && res.data.estado) {
                        this.selectedYear = 2026;
                        this.resumen = res.data.totales || this.resumen;
                        this.meses = res.data.meses || [];
                        this.contactos = res.data.contactos || [];
                        this.carrerasDisponibles = res.data.carreras_disponibles || [];
                        this.simuladorSync = res.data.sync || this.simuladorSync;
                        this.currentPage = 1;
                    }
                })
                .catch((error) => {
                    const mensaje = error?.response?.data?.mensaje || 'No se pudo cargar Simulador.';
                    Swal.fire({ icon: 'error', title: mensaje, showConfirmButton: true });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async sincronizarHubSpotSimulador() {
            if (this.isSyncingHubSpot) {
                return;
            }

            const confirmacion = await Swal.fire({
                icon: 'question',
                title: 'Actualizar Simulador desde HubSpot',
                text: this.simuladorSync?.last_hubspot_created_at
                    ? 'Se traerán todas las actividades nuevas de HubSpot para 2026 desde la última sincronización registrada. Puede tardar unos minutos.'
                    : 'Primera sincronización: se traerán todas las actividades 2026 de HubSpot que contengan Simulador. Puede tardar unos minutos.',
                showCancelButton: true,
                confirmButtonText: 'Actualizar',
                cancelButtonText: 'Cancelar',
            });

            if (!confirmacion.isConfirmed) {
                return;
            }

            this.isSyncingHubSpot = true;

            try {
                const { data } = await axios.post('/api/sync_simulador_hubspot', {
                    year: 2026
                });
                this.simuladorSync = data.sync || this.simuladorSync;
                await this.cargar();

                Swal.fire({
                    icon: data.quedan_mas_lotes ? 'info' : 'success',
                    title: data.mensaje || 'Simulador actualizado desde HubSpot.',
                    text: data.quedan_mas_lotes
                        ? 'Aún quedan actividades pendientes en HubSpot. Presiona nuevamente Actualizar desde HubSpot para traer el siguiente lote.'
                        : '',
                    showConfirmButton: true,
                });
            } catch (error) {
                const mensaje = error?.response?.data?.mensaje || 'No se pudo sincronizar Simulador desde HubSpot.';
                Swal.fire({ icon: 'error', title: mensaje, showConfirmButton: true });
            } finally {
                this.isSyncingHubSpot = false;
            }
        },
        formatFecha(fecha) {
            if (!fecha) return '—';
            return new Date(fecha).toLocaleString('es-CL', {
                day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
            });
        },
        nombreContacto(c) {
            return c?.nombre || c?.email || c?.rut || 'Sin nombre';
        },
        formatValor(valor) {
            return valor ? valor : '—';
        },
        formatSyncDate(fecha) {
            return fecha ? this.formatFecha(fecha) : 'Sin sincronización previa';
        },
        formatFechaCSV(fecha) {
            if (!fecha) return '';
            return new Date(fecha).toLocaleString('es-CL', {
                day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
            });
        },
        normalizarNombreArchivo(valor) {
            return String(valor || 'todas')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9_-]+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^_|_$/g, '')
                .toLowerCase() || 'todas';
        },
        escaparCSV(valor) {
            const v = valor === null || valor === undefined ? '' : String(valor);
            const limpio = v.replace(/\r?\n|\r/g, ' ').replace(/"/g, '""');
            return `"${limpio}"`;
        },
        descargarContactosCSV() {
            const filas = this.contactosBuscados || [];

            if (!filas.length) {
                Swal.fire({
                    icon: 'info',
                    title: 'No hay contactos para descargar',
                    showConfirmButton: true,
                });
                return;
            }

            const headers = [
                'Mes',
                'Fecha actividad',
                'Carrera',
                'Nombre',
                'RUT',
                'Email',
                'Celular',
                'Curso',
                'Establecimiento',
                'Preferencia 1',
                'Preferencia 2',
                'Preferencia 3',
                'Marcador Paso Simulador',
                'Región Colegio',
                'Comuna Colegio',
                'Beca del Estado Asignada',
                'Beca UGM Simulador',
                'Ranking',
                'Monto CAE',
                'PAES Ciencias',
                'PAES Competencias Lectoras',
                'PAES Historia',
                'PAES M1',
                'PAES M2',
                'NEM',
                'Actividad',
                'Colegio actividad',
                'Codigo actividad',
                'HubSpot actividad ID',
            ];

            const csvRows = [headers.join(',')];

            filas.forEach((c) => {
                const row = [
                    c.mes_label || '',
                    this.formatFechaCSV(c.fecha_actividad),
                    c.carrera || '',
                    this.nombreContacto(c) || '',
                    c.rut || '',
                    c.email || '',
                    c.celular || '',
                    c.curso || '',
                    c.establecimiento || '',
                    c.preferencia_1 || '',
                    c.preferencia_2 || '',
                    c.preferencia_3 || '',
                    c.marcador_paso_simulador || '',
                    c.region_colegio || '',
                    c.comuna_colegio || '',
                    c.beca_estado_asignada || '',
                    c.beca_ugm_simulador || '',
                    c.ranking || '',
                    c.monto_cae || '',
                    c.paes_ciencias || '',
                    c.paes_lectoras || '',
                    c.paes_historia || '',
                    c.paes_m1 || '',
                    c.paes_m2 || '',
                    c.nem_puntaje || '',
                    c.actividad || '',
                    c.colegio_actividad || '',
                    c.codigo_actividad || '',
                    c.hubspot_actividad_id || '',
                ].map(this.escaparCSV);

                csvRows.push(row.join(','));
            });

            const csvContent = "\uFEFF" + csvRows.join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            const carreraSegmento = this.normalizarNombreArchivo(this.carreraFiltro || 'todas');
            const periodoSegmento = this.periodo === 'mes'
                ? `2026-${String(this.selectedMonth).padStart(2, '0')}`
                : '2026';

            link.href = url;
            link.setAttribute('download', `simulador_contactos_${carreraSegmento}_${periodoSegmento}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        goToPage(page) {
            const nextPage = Math.min(Math.max(1, page), this.totalPages);
            this.currentPage = nextPage;
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="card shadow-sm mb-4">
            <div class="card-header py-3 d-flex align-items-center"
                 style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                <i class="bx bx-slider-alt font-size-20 text-white mr-2"></i>
                <div>
                    <h6 class="mb-0 text-white font-weight-bold">Filtros de consulta</h6>
                    <small class="text-white" style="opacity:.8;">Mismo período y carrera aplican al detalle y a la descarga CSV</small>
                </div>
            </div>
            <div class="card-body py-4">
                <div class="row align-items-end sim-filter-row">
                    <div class="col-12 col-sm-6 col-lg-3 mb-3">
                        <label class="mb-1 font-weight-semibold">Consulta</label>
                        <select class="form-control" v-model="periodo">
                            <option value="anio">Consolidado anual</option>
                            <option value="mes">Consolidado mensual</option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-2 mb-3">
                        <label class="mb-1 font-weight-semibold">Año</label>
                        <input class="form-control" value="2026" disabled>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-2 mb-3" v-if="periodo === 'mes'">
                        <label class="mb-1 font-weight-semibold">Mes</label>
                        <select class="form-control" v-model.number="selectedMonth">
                            <option v-for="m in mesesDisponibles" :key="m.value" :value="m.value">{{ m.label }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-lg mb-3">
                        <label class="mb-1 font-weight-semibold">Filtrar por carrera</label>
                        <select class="form-control" v-model="carreraFiltro">
                            <option value="">Todas</option>
                            <option v-for="c in opcionesCarrera" :key="c" :value="c">{{ c }}</option>
                        </select>
                    </div>
                    <div class="col-12">
                        <div class="sim-filtros-actions">
                            <button class="btn btn-ugm-dark" :disabled="isLoading || isSyncingHubSpot" @click="cargar">
                                <i class="mdi mdi-refresh mr-1"></i> Consultar
                            </button>
                            <button class="btn btn-outline-primary" :disabled="isLoading || isSyncingHubSpot" @click="sincronizarHubSpotSimulador">
                                <i class="mdi mr-1" :class="isSyncingHubSpot ? 'mdi-loading mdi-spin' : 'mdi-cloud-download-outline'"></i>
                                {{ isSyncingHubSpot ? 'Sincronizando...' : 'Actualizar desde HubSpot' }}
                            </button>
                            <button class="btn btn-ugm-gold" :disabled="isSyncingHubSpot" @click="descargarContactosCSV">
                                <i class="mdi mdi-download mr-1"></i> Descargar contactos CSV
                            </button>
                            <small class="sim-sync-meta text-muted">
                                Última sync: {{ formatSyncDate(simuladorSync.last_synced_at) }}
                                <span v-if="simuladorSync.last_status">· {{ simuladorSync.last_status }}</span>
                                <span v-if="simuladorSync.last_totals && simuladorSync.last_totals.quedan_mas_lotes">· quedan más lotes por traer</span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-4">
            <div class="col-md-3 col-6 mb-3">
                <div class="card shadow-sm h-100" style="border-left:4px solid #252C5F;">
                    <div class="card-body py-3 px-4">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Actividades</p>
                                <h3 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ resumen.actividades }}</h3>
                                <small class="text-muted">registradas en simulador</small>
                            </div>
                            <div class="rounded-circle d-flex align-items-center justify-content-center sim-kpi-icon" style="background:rgba(37,44,95,.1);color:#252C5F;">
                                <i class="bx bx-calendar-event"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-6 mb-3">
                <div class="card shadow-sm h-100" style="border-left:4px solid #61B7E4;">
                    <div class="card-body py-3 px-4">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Meses</p>
                                <h3 class="mb-0 font-weight-bold" style="color:#61B7E4;">{{ resumen.meses }}</h3>
                                <small class="text-muted">con consolidado disponible</small>
                            </div>
                            <div class="rounded-circle d-flex align-items-center justify-content-center sim-kpi-icon" style="background:rgba(97,183,228,.14);color:#61B7E4;">
                                <i class="bx bx-layer"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-6 mb-3">
                <div class="card shadow-sm h-100" style="border-left:4px solid #CB9700;">
                    <div class="card-body py-3 px-4">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Contactos</p>
                                <h3 class="mb-0 font-weight-bold" style="color:#CB9700;">{{ resumen.contactos }}</h3>
                                <small class="text-muted">consolidado mínimo del período</small>
                            </div>
                            <div class="rounded-circle d-flex align-items-center justify-content-center sim-kpi-icon" style="background:rgba(203,151,0,.14);color:#CB9700;">
                                <i class="bx bx-user-pin"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-6 mb-3">
                <div class="card shadow-sm h-100" style="border-left:4px solid #9b59b6;">
                    <div class="card-body py-3 px-4">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <p class="mb-1 font-size-11 text-uppercase font-weight-bold text-muted">Contactos únicos</p>
                                <h3 class="mb-0 font-weight-bold" style="color:#9b59b6;">{{ resumen.contactos_unicos }}</h3>
                                <small class="text-muted">1 mínimo por simulación</small>
                            </div>
                            <div class="rounded-circle d-flex align-items-center justify-content-center sim-kpi-icon" style="background:rgba(155,89,182,.12);color:#9b59b6;">
                                <i class="bx bx-user-check"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isLoading" class="text-center py-5">
            <div class="spinner-border" style="color:#252C5F;" role="status"></div>
            <p class="mt-3 text-muted">Cargando simulaciones...</p>
        </div>

        <div v-else>
            <div class="row mb-4">
                <div class="col-lg-8 mb-3 mb-lg-0">
                    <div class="sim-info-banner">
                        <div>
                            <span class="sim-info-label">Carreras detectadas</span>
                            <strong>{{ resumen.carreras }}</strong>
                        </div>
                        <div>
                            <span class="sim-info-label">Filtro aplicado</span>
                            <strong>{{ carreraFiltro || 'Todas las carreras' }}</strong>
                        </div>
                        <div>
                            <span class="sim-info-label">Exportación lista</span>
                            <strong>{{ contactosBuscados.length }} filas</strong>
                        </div>
                        <div>
                            <span class="sim-info-label">Detalle persistido</span>
                            <strong>{{ resumen.contactos_detalle_persistidos || 0 }}</strong>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="sim-empty-hint h-100">
                        <i class="bx bx-data"></i>
                        <div>
                            <strong>Fuente única</strong>
                            <p class="mb-0">Los datos visibles y el CSV salen desde la base persistida, no desde HubSpot en vivo.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-lg-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-bookmark-heart font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Preferencia 1</h6>
                                <small class="text-white" style="opacity:.8;">Consolidado de contactos del simulador</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="preferencias1Consolidadas.length"
                                type="bar"
                                height="260"
                                :options="chartPreferencias1.options"
                                :series="chartPreferencias1.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin preferencias 1 disponibles para el filtro seleccionado.</div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header py-3 d-flex align-items-center"
                             style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                            <i class="bx bx-bookmark-star font-size-20 text-white mr-2"></i>
                            <div>
                                <h6 class="mb-0 text-white font-weight-bold">Preferencia 2</h6>
                                <small class="text-white" style="opacity:.8;">Consolidado de contactos del simulador</small>
                            </div>
                        </div>
                        <div class="card-body pt-3 pb-2">
                            <apexchart v-if="preferencias2Consolidadas.length"
                                type="bar"
                                height="260"
                                :options="chartPreferencias2.options"
                                :series="chartPreferencias2.series">
                            </apexchart>
                            <div v-else class="text-center py-4 text-muted">Sin preferencias 2 disponibles para el filtro seleccionado.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card shadow-sm mb-4">
                <div class="card-header py-3 d-flex align-items-center justify-content-between"
                     style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                    <div class="d-flex align-items-center">
                        <i class="bx bx-table font-size-20 text-white mr-2"></i>
                        <div>
                            <h6 class="mb-0 text-white font-weight-bold">Consolidado por mes</h6>
                            <small class="text-white" style="opacity:.8;">Resumen de actividades, carreras y contactos persistidos</small>
                            <small class="text-white d-block" style="opacity:.8;">Si falta detalle persistido, el consolidado cuenta 1 contacto mínimo por simulación.</small>
                        </div>
                    </div>
                    <span class="badge sim-header-badge">{{ meses.length }} meses</span>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-sm table-hover mb-0 sim-table">
                            <thead style="background:#f8f9fc;">
                                <tr>
                                    <th>Mes</th>
                                    <th>Actividades</th>
                                    <th>Carreras</th>
                                    <th>Contactos</th>
                                    <th>Contactos únicos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="m in meses" :key="m.mes">
                                    <td class="font-weight-semibold" style="color:#252C5F;">{{ m.mes_label }}</td>
                                    <td>{{ m.actividades_total }}</td>
                                    <td>{{ m.carreras_total }}</td>
                                    <td>{{ m.contactos_total }}</td>
                                    <td class="font-weight-bold">{{ m.contactos_unicos }}</td>
                                </tr>
                                <tr v-if="!meses.length">
                                    <td colspan="5" class="text-center text-muted py-4">No hay datos para el período seleccionado.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card shadow-sm mb-3">
                <div class="card-header py-3 d-flex align-items-center justify-content-between"
                     style="background:linear-gradient(135deg,#252C5F 0%,#61B7E4 100%);border-radius:4px 4px 0 0;">
                    <div class="d-flex align-items-center">
                        <i class="bx bx-user-circle font-size-20 text-white mr-2"></i>
                        <div>
                            <h6 class="mb-0 text-white font-weight-bold">Detalle de contactos</h6>
                            <small class="text-white" style="opacity:.8;">La tabla y el CSV comparten exactamente este mismo filtro</small>
                        </div>
                    </div>
                    <span class="badge sim-header-badge">{{ contactosBuscados.length }} filas</span>
                </div>
                <div class="card-body p-0">
                    <div class="sim-table-toolbar">
                        <div class="sim-table-toolbar-left">
                            <label class="mb-0 font-weight-semibold">Buscar en detalle</label>
                            <input
                                v-model="searchQuery"
                                type="text"
                                class="form-control sim-search-input"
                                placeholder="Buscar por nombre, RUT, email, carrera, actividad..."
                            >
                        </div>
                        <div class="sim-table-toolbar-right text-muted">
                            Mostrando {{ paginationStart }}-{{ paginationEnd }} de {{ contactosBuscados.length }}
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm table-hover mb-0 sim-table sim-table-wide">
                            <thead style="background:#f8f9fc;">
                                <tr>
                                    <th>Mes</th>
                                    <th>Fecha actividad</th>
                                    <th>Carrera</th>
                                    <th>Nombre</th>
                                    <th>RUT</th>
                                    <th>Email</th>
                                    <th>Celular</th>
                                    <th>Curso</th>
                                    <th>Establecimiento</th>
                                    <th>Pref. 1</th>
                                    <th>Pref. 2</th>
                                    <th>Pref. 3</th>
                                    <th>Marcador</th>
                                    <th>Región</th>
                                    <th>Comuna</th>
                                    <th>Beca Estado</th>
                                    <th>Beca UGM</th>
                                    <th>Ranking</th>
                                    <th>Monto CAE</th>
                                    <th>PAES Ciencias</th>
                                    <th>PAES Lectoras</th>
                                    <th>PAES Historia</th>
                                    <th>PAES M1</th>
                                    <th>PAES M2</th>
                                    <th>NEM</th>
                                    <th>Actividad</th>
                                    <th>Colegio</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="c in contactosPaginados" :key="(c.hubspot_actividad_id || 'h') + '-' + (c.contacto_id || 'c') + '-' + (c.fecha_actividad || 'f')">
                                    <td>{{ formatValor(c.mes_label) }}</td>
                                    <td>{{ formatFecha(c.fecha_actividad) }}</td>
                                    <td class="font-weight-semibold">{{ formatValor(c.carrera) }}</td>
                                    <td>{{ formatValor(nombreContacto(c)) }}</td>
                                    <td>{{ formatValor(c.rut) }}</td>
                                    <td>{{ formatValor(c.email) }}</td>
                                    <td>{{ formatValor(c.celular) }}</td>
                                    <td>{{ formatValor(c.curso) }}</td>
                                    <td>{{ formatValor(c.establecimiento) }}</td>
                                    <td>{{ formatValor(c.preferencia_1) }}</td>
                                    <td>{{ formatValor(c.preferencia_2) }}</td>
                                    <td>{{ formatValor(c.preferencia_3) }}</td>
                                    <td>{{ formatValor(c.marcador_paso_simulador) }}</td>
                                    <td>{{ formatValor(c.region_colegio) }}</td>
                                    <td>{{ formatValor(c.comuna_colegio) }}</td>
                                    <td>{{ formatValor(c.beca_estado_asignada) }}</td>
                                    <td>{{ formatValor(c.beca_ugm_simulador) }}</td>
                                    <td>{{ formatValor(c.ranking) }}</td>
                                    <td>{{ formatValor(c.monto_cae) }}</td>
                                    <td>{{ formatValor(c.paes_ciencias) }}</td>
                                    <td>{{ formatValor(c.paes_lectoras) }}</td>
                                    <td>{{ formatValor(c.paes_historia) }}</td>
                                    <td>{{ formatValor(c.paes_m1) }}</td>
                                    <td>{{ formatValor(c.paes_m2) }}</td>
                                    <td>{{ formatValor(c.nem_puntaje) }}</td>
                                    <td>{{ formatValor(c.actividad) }}</td>
                                    <td>{{ formatValor(c.colegio_actividad) }}</td>
                                </tr>
                                <tr v-if="!contactosPaginados.length">
                                    <td colspan="26" class="text-center text-muted py-4">No hay contactos para el filtro seleccionado.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="sim-pagination">
                        <button class="btn btn-sm btn-outline-secondary" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                            Anterior
                        </button>
                        <span class="sim-pagination-status">Página {{ currentPage }} de {{ totalPages }}</span>
                        <button class="btn btn-sm btn-outline-secondary" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.card { border: none; border-radius: 8px; }
.card-header { border-bottom: none; }
.sim-kpi-icon {
    width: 48px;
    height: 48px;
    font-size: 22px;
}
.sim-info-banner {
    height: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    background: #f8f9fc;
    border: 1px solid #e9edf6;
    border-radius: 12px;
    padding: 14px 16px;
}
.sim-info-banner strong {
    display: block;
    color: #252C5F;
    font-size: 15px;
    line-height: 1.3;
}
.sim-info-label {
    display: block;
    color: #7a8599;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .08em;
    margin-bottom: 4px;
}
.sim-empty-hint {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(203,151,0,.08);
    border: 1px solid rgba(203,151,0,.16);
    border-radius: 12px;
    padding: 16px;
    color: #5f4a09;
}
.sim-empty-hint i {
    font-size: 28px;
    color: #CB9700;
}
.sim-header-badge {
    background: rgba(255,255,255,.2);
    color: #fff;
    border-radius: 999px;
    padding: 5px 11px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .03em;
}
.sim-table thead th {
    color: #252C5F;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .06em;
    border-top: none;
    border-bottom: 1px solid #edf1f7;
    padding: 12px 14px;
    white-space: nowrap;
}
.sim-table tbody td {
    padding: 11px 14px;
    vertical-align: middle;
    border-color: #f1f4fa;
}
.sim-table-wide tbody td,
.sim-table-wide thead th {
    min-width: 120px;
}
.sim-table-toolbar {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 16px 12px;
    border-bottom: 1px solid #eef2f8;
}
.sim-table-toolbar-left {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1 420px;
}
.sim-table-toolbar-right {
    font-size: 13px;
    white-space: nowrap;
}
.sim-search-input {
    max-width: 520px;
}
.sim-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 16px 16px;
    border-top: 1px solid #eef2f8;
}
.sim-pagination-status {
    color: #5f6b7a;
    font-size: 13px;
    min-width: 120px;
    text-align: center;
}
.btn-ugm-dark {
    background-color: #252C5F;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 600;
}
.btn-ugm-dark:hover {
    background-color: #1a1f44;
    color: #fff;
}
.btn-ugm-gold {
    background-color: #CB9700;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 600;
}
.btn-ugm-gold:hover {
    background-color: #a87c00;
    color: #fff;
}
.sim-filter-row .form-control {
    min-height: 38px;
}
.sim-filtros-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
}
.sim-filtros-actions .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 36px;
    white-space: nowrap;
}
.sim-sync-meta {
    display: block;
    width: 100%;
    text-align: right;
    font-size: 12px;
}
@media (max-width: 991.98px) {
    .sim-info-banner {
        grid-template-columns: 1fr;
    }
    .sim-filtros-actions {
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .sim-sync-meta {
        text-align: left;
    }
    .sim-table-toolbar {
        flex-direction: column;
        align-items: stretch;
    }
    .sim-table-toolbar-right {
        white-space: normal;
    }
    .sim-search-input {
        max-width: 100%;
    }
    .sim-pagination {
        justify-content: center;
        flex-wrap: wrap;
    }
}
</style>
